import { AxiosPromise } from 'axios';

import {
  INewAssetStatusParams,
  IUpdatedAssetStatusParams,
  IAssetStatus,
  IAssetStatusCleanupParams,
} from './interfaces';
import { vaultApi } from '../api';
import { getAuthorizationHeaders } from '../../../utils/sso';
import { IApiResponse } from '../interfaces';

const basePath = '/assetStatus';

/* eslint-disable implicit-arrow-linebreak,arrow-parens */

export const getRecentlyCreated = <T>(
  orgId: number,
  fetchAll: boolean = false,
  videoType: string[] = [],
  includeExchangeEvents: boolean = false,
): AxiosPromise<IApiResponse<IAssetStatus[]>> => {
  let queryString = fetchAll ? 'filterByOrg=false' : `orgId=${orgId}`;
  if (videoType && videoType.length > 0) queryString += `&videoType=${videoType.join(',')}`;
  if (includeExchangeEvents) queryString += `&includeExchangeEvents=${includeExchangeEvents}`;
  return vaultApi.getInstance().get(`${basePath}?${queryString}`);
};

export const createAssetStatus = <T>(params: INewAssetStatusParams): AxiosPromise<any> =>
  vaultApi.getInstance().post(`${basePath}`, params);

export const updateAssetStatus = <T>(id: string, params: IUpdatedAssetStatusParams): AxiosPromise<any> =>
  vaultApi.getInstance().put(`${basePath}/${id}`, params);

export const deleteAssetStatus = <T>(id: string): AxiosPromise<any> =>
  vaultApi.getInstance().delete(`${basePath}/${id}`);

export const cleanupAssetStatuses = <T>(params: IAssetStatusCleanupParams): Promise<any> => {
  const { fetch } = window;
  // note: keep-alive http agent does not work for axios
  // - defaulting to fetch to ensure endpoint is hit consistently
  return fetch(`${process.env.REACT_APP_VAULT_API_URL}${basePath}/cleanup`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
      ...getAuthorizationHeaders(),
    },
    keepalive: true,
  });
};

export const getAssetStatus = <T>(id: string): AxiosPromise<any> =>
  vaultApi.getInstance().get(`${basePath}/${id}`);

export const deleteManyAssetStatus = <T>(ids: string[]): AxiosPromise<any> =>
  vaultApi.getInstance().put(`${basePath}/delete/deleteMany`, { ids });
